import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'

import Login from '../views/LoginView.vue'
import Home from '../views/HomeView.vue'
import ResetSenha from '../views/ResetSenhaView.vue'
import GrupoTelasInstitucional from '../views/Adm/GrupoTelasInstitucionalView.vue'
import CadastroTelasInstitucional from '../views/Adm/CadastroTelasInstitucionalView.vue'
import ConfigInstitucional from '../views/Adm/ConfigInstitucionalView.vue'
import ConfigListaImagens from '../views/Adm/ConfigListaImagensView.vue'
import ConfigListaArquivos from '../views/Adm/ConfigListaArquivosView.vue'
import ConfigListaGrids from '../views/Adm/ConfigListaGridsView.vue'
import ImportacaoInstitucional from '../views/Adm/ImportacaoInstitucionalView.vue'
import CadastroTipoUsuario from '../views/Adm/CadastroTipoUsuarioView.vue'
import CadastroUsuarios from '../views/Usuarios/CadastroUsuariosView.vue'
import ControlePermissoes from '../views/Usuarios/ControlePermissoesView.vue'
import Institucional from '../views/Institucional/InstitucionalView.vue'
import SegmentosInst from '../views/Institucional/SegmentosInstView.vue'
import AdminAgentes from '../views/Agentes/AdminAgentesView.vue'
import AgenteDetalhe from '../views/Agentes/AgenteDetalheView.vue'
import Conhecimento from '../views/Agentes/ConhecimentoView.vue'
import Ferramentas from '../views/Agentes/FerramentasView.vue'
import ConfiguracaoAgente from '../views/Agentes/ConfiguracaoAgenteView.vue'

const routes = [
  { path: '/', name: 'login', component: Login },
  { path: '/Home', name: 'Home', component: Home },
  { path: '/ResetSenha/:id/:key', name: 'ResetSenha', component: ResetSenha },
  { path: '/GrupoTelasInstitucional', name: 'GrupoTelasInstitucional', component: GrupoTelasInstitucional },
  { path: '/CadastroTelasInstitucional', name: 'CadastroTelasInstitucional', component: CadastroTelasInstitucional },
  { path: '/ConfigInstitucional', name: 'ConfigInstitucional', component: ConfigInstitucional },
  { path: '/ConfigListaImagens', name: 'ConfigListaImagens', component: ConfigListaImagens },
  { path: '/ConfigListaArquivos', name: 'ConfigListaArquivos', component: ConfigListaArquivos },
  { path: '/ConfigListaGrids', name: 'ConfigListaGrids', component: ConfigListaGrids },
  { path: '/ImportacaoInstitucional', name: 'ImportacaoInstitucional', component: ImportacaoInstitucional },
  { path: '/CadastroTipoUsuario', name: 'CadastroTipoUsuario', component: CadastroTipoUsuario },
  { path: '/CadastroUsuarios', name: 'CadastroUsuarios', component: CadastroUsuarios },
  { path: '/ControlePermissoes', name: 'ControlePermissoes', component: ControlePermissoes },
  { path: '/Institucional/:id/:nome', name: 'Institucional', component: Institucional },
  { path: '/SegmentosInst', name: 'SegmentosInst', component: SegmentosInst },
  { path: '/AdminAgentes', name: 'AdminAgentes', component: AdminAgentes },
  { path: '/AdminAgentes/:id', name: 'AgenteDetalhe', component: AgenteDetalhe },
  { path: '/AdminAgentes/:id/Finalizadas', name: 'AgenteFinalizadas', component: AgenteDetalhe },
  { path: '/AdminAgentes/:id/Conhecimento', name: 'Conhecimento', component: Conhecimento },
  { path: '/AdminAgentes/:id/Ferramentas', name: 'Ferramentas', component: Ferramentas },
  { path: '/AdminAgentes/:id/Configuracao', name: 'ConfiguracaoAgente', component: ConfiguracaoAgente },
  { path: '/:pathMatch(.*)*', redirect: '/Home' },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

const publicRoutes = ['login', 'ResetSenha']

router.beforeEach(async (to, from, next) => {
  window.scrollTo({ top: 0, behavior: 'smooth' })

  if (publicRoutes.includes(to.name)) {
    next()
    return
  }

  try {
    const response = await axios.get('/Auth/Me')
    sessionStorage.setItem('_userav', JSON.stringify({
      cusId: response.data.cusId || response.data.CusId,
      nome: response.data.nome || response.data.Nome,
      urlimage: response.data.urlImage || response.data.UrlImage,
      menu: response.data.menu || response.data.Menu || []
    }))
    next()
  } catch {
    sessionStorage.removeItem('_userav')
    next('/')
  }
})

export default router
